export default __webpack_public_path__ + "static/media/step3-3.57a84cb0.jpg";